import axios from "../../axios"

const header = (token) => {
  return {
    headers: {
        Authorization: "Bearer " + token
    }
  }
}

export default {
  async fetchRoles(token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/role';
    try {
  
      return await axios.get('', header(token));
  
    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async fetchRoleById(token, id) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/role/id';
    try {
  
      return await axios.get('',  {
        params: {
          id: id
        },
        ...header(token)
      });
  
    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async createRole(token, name) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/role';
    try {
  
      return await axios.post('',  {
        name: name
      }, header(token));
  
    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  }
}